"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { TextArea as AriaTextArea, Label, Text, TextField } from "react-aria-components";
type TextAreaInputProps = {
  label?: string;
  name: string;
  description?: string;
  errorMessage?: string;
  className?: string;
  inputClassName?: string;
  rows?: number;
};
export const TextAreaInput = t0 => {
  const $ = _c(32);
  let className;
  let description;
  let errorMessage;
  let inputClassName;
  let label;
  let name;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      label,
      name,
      description,
      errorMessage,
      className,
      inputClassName,
      rows: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = description;
    $[3] = errorMessage;
    $[4] = inputClassName;
    $[5] = label;
    $[6] = name;
    $[7] = props;
    $[8] = t1;
  } else {
    className = $[1];
    description = $[2];
    errorMessage = $[3];
    inputClassName = $[4];
    label = $[5];
    name = $[6];
    props = $[7];
    t1 = $[8];
  }
  const rows = t1 === undefined ? 3 : t1;
  let t2;
  if ($[9] !== className) {
    t2 = cn("flex flex-col py-3 my-3 gap-2", className);
    $[9] = className;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== label || $[12] !== name) {
    t3 = label && <Label htmlFor={name} className="text-title-medium">{label}</Label>;
    $[11] = label;
    $[12] = name;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const t4 = errorMessage ? "border-primary-500" : "border-gray-300";
  let t5;
  if ($[14] !== inputClassName || $[15] !== t4) {
    t5 = cn("border border-gray-300 px-3 py-3 rounded-lg text-body resize-none focus:outline-none focus:border-primary-600 focus:shadow-none", t4, inputClassName);
    $[14] = inputClassName;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== name || $[18] !== props || $[19] !== rows || $[20] !== t5) {
    t6 = <AriaTextArea id={name} rows={rows} {...props} className={t5} />;
    $[17] = name;
    $[18] = props;
    $[19] = rows;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== description) {
    t7 = description && <Text slot="description" className="text-body-small">{description}</Text>;
    $[22] = description;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const t8 = errorMessage || "";
  let t9;
  if ($[24] !== t8) {
    t9 = <Text slot="errorMessage" className="text-body-small-medium text-destructive h-1">{t8}</Text>;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t2 || $[27] !== t3 || $[28] !== t6 || $[29] !== t7 || $[30] !== t9) {
    t10 = <TextField className={t2}>{t3}{t6}{t7}{t9}</TextField>;
    $[26] = t2;
    $[27] = t3;
    $[28] = t6;
    $[29] = t7;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};